// Dictionary of the cabinet core: layout, sign-in second step, shared UI primitives, status and event labels.
// Keys are the exact Russian source strings used in t(); every key here must exist in both en and uk.
export default {
  en: {
    'Отмена действия': 'Undo',
    'Режим просмотра': 'View mode',
    'Длительность': 'Duration',
    // format.ts: email statuses
    'В очереди': 'Queued',
    'Передано': 'Handed over',
    'Доставлено': 'Delivered',
    'Отскок': 'Bounced',
    'Жалоба': 'Complaint',
    'Ошибка': 'Error',
    'Неизвестно': 'Unknown',
    'Подавлено': 'Suppressed',
    'Отменено MailOcean': 'Cancelled by MailOcean',
    'Принято API, ждёт передачи провайдеру': 'Accepted by the API, waiting to be handed to the provider',
    'Провайдер принял письмо': 'The provider accepted the email',
    'Почтовый сервер получателя подтвердил приём': "The recipient's mail server confirmed receipt",
    'Постоянный отказ сервера получателя': "Permanent refusal by the recipient's server",
    'Получатель отметил письмо как спам — добавлен в подавления': 'The recipient marked the email as spam — added to suppressions',
    'Провайдер окончательно отклонил письмо': 'The provider permanently rejected the email',
    'Результат передачи неизвестен; повторно не отправляем, чтобы не создать дубль': 'The delivery result is unknown; we do not resend, to avoid a duplicate',
    'Адрес в списке подавлений — письмо не отправлялось': 'The address is in the suppression list — the email was not sent',
    'Отменено сотрудником MailOcean до передачи провайдеру — письмо не отправлялось': 'Cancelled by a MailOcean employee before handover to the provider — the email was not sent',
    // format.ts: timeline events
    'Принято API': 'Accepted by the API',
    'Поставлено в очередь': 'Queued',
    'Передано провайдеру': 'Handed to the provider',
    'Провайдер принял': 'Provider accepted',
    'Повтор запланирован': 'Retry scheduled',
    'Результат неизвестен': 'Result unknown',
    'Отклонено': 'Rejected',
    'Доставлено получателю': 'Delivered to the recipient',
    'Мягкий отскок': 'Soft bounce',
    'Отложено сервером получателя': "Deferred by the recipient's server",
    'Жалоба на спам': 'Spam complaint',
    'Исход сверен поддержкой MailOcean': 'Outcome reconciled by MailOcean support',
    // format.ts: bounce categories
    'Адреса не существует или ящик отключён': 'The address does not exist or the mailbox is disabled',
    'Ящик переполнен': 'Mailbox full',
    'Сервер получателя ограничил отправителя по репутации': "The recipient's server limited the sender by reputation",
    'Не прошла проверка SPF/DKIM/DMARC домена отправителя': 'The sender domain failed the SPF/DKIM/DMARC check',
    'Проблема инфраструктуры отправки (PTR/TLS) — мы разбираемся': 'A sending infrastructure issue (PTR/TLS) — we are looking into it',
    'Отказ из-за содержимого или ссылок': 'Refused because of the content or the links',
    'Письмо нарушает формат (RFC 5322)': 'The email breaks the format (RFC 5322)',
    'Организация получателя не принимает такие письма (нужен allowlist)': 'The recipient organisation does not accept such emails (an allowlist is needed)',
    'Отказ по политике сервера получателя': "Refused under the recipient server's policy",
    'Сервер получателя ограничил скорость': "The recipient's server limited the sending rate",
    'Временная ошибка': 'Temporary error',
    'Получатель пожаловался на спам': 'The recipient complained about spam',
    'Причина не распознана — мы разбираем такие ответы': 'The reason is not recognised — we review such replies',
    // format.ts: explanations under a timeline event
    'Сервер получателя попросил повторить позже — повтор идёт': "The recipient's server asked to retry later — retrying",
    'Не доставлено: истёк срок повторов': 'Not delivered: the retry period has expired',
    'Адрес добавлен в подавления': 'The address was added to suppressions',
    'Адрес не подавлен: причина на стороне отправителя, а не получателя': "The address was not suppressed: the cause is on the sender's side, not the recipient's",
    'Адрес не подавлен': 'The address was not suppressed',
    // Layout.tsx
    'океан писем': 'ocean of email',
    'Продолжить погружение': 'Continue the deep dive',
    'Отправка': 'Sending',
    'Аудитория': 'Audience',
    'Маркетинг': 'Marketing',
    'Аккаунт': 'Account',
    'Обзор': 'Overview',
    'Письма': 'Emails',
    'Шаблоны': 'Templates',
    'Каналы': 'Channels',
    'Уведомления': 'Notifications',
    'Домены': 'Domains',
    'API-ключи': 'API keys',
    'Вебхуки': 'Webhooks',
    'Детектив': 'Detective',
    'Контакты': 'Contacts',
    'События': 'Events',
    'Сегменты': 'Segments',
    'Подавления': 'Suppressions',
    'Пилот': 'Pilot',
    'Сценарии': 'Journeys',
    'Команда': 'Team',
    'Безопасность': 'Security',
    'Тариф и оплата': 'Plan and billing',
    'Журнал': 'Log',
    'Настройки': 'Settings',
    'Правила (без AI)': 'Rules (no AI)',
    'правила': 'rules',
    'Сменить тему': 'Switch theme',
    'Выйти': 'Sign out',
    'Сменить рабочее пространство': 'Switch workspace',
    'Новое пространство': 'New workspace',
    'Название нового рабочего пространства': 'Name of the new workspace',
    'Язык интерфейса': 'Interface language',
    'Отправка заблокирована MailOcean: API не принимает новые письма.': 'Sending is blocked by MailOcean: the API does not accept new emails.',
    'Отправка приостановлена MailOcean: письма принимаются и ждут в очереди.': 'Sending is paused by MailOcean: emails are accepted and wait in the queue.',
    'Напишите в поддержку, чтобы узнать подробности': 'Contact support to learn more',
    'Письма, уже переданные провайдеру, остановить нельзя.': 'Emails already handed to the provider cannot be stopped.',
    'Поток «{streams}» приостановлен MailOcean.': 'The «{streams}» stream is paused by MailOcean.',
    'маркетинг': 'marketing',
    'транзакционные': 'transactional',
    'Письма этого потока ждут в очереди; остальные отправляются как обычно.': 'Emails of this stream wait in the queue; the others are sent as usual.',
    'Режим просмотра поддержки — только чтение.': 'Support view mode — read only.',
    '{name} из MailOcean смотрит пространство так, как его видит владелец; изменить ничего нельзя. Доступ записан в журнал действий.': '{name} from MailOcean is viewing the workspace as the owner sees it; nothing can be changed. Access is recorded in the activity log.',
    'Письма · детали': 'Emails · details',
    'Домены · DNS': 'Domains · DNS',
    'Контакты · карточка': 'Contacts · card',
    'Сегменты · редактор': 'Segments · editor',
    'Пилот · словарь': 'Pilot · vocabulary',
    'Пилот · поручение': 'Pilot · task',
    'Сценарии · течение': 'Journeys · flow',
    'Каналы · политика': 'Channels · policy',
    'Каналы · политики': 'Channels · policies',
    'Каналы · шаблон': 'Channels · template',
    'Каналы · шаблоны': 'Channels · templates',
    'Каналы · расходы': 'Channels · costs',
    'Каналы · настройки': 'Channels · settings',
    'Каналы · SMS': 'Channels · SMS',
    'Каналы · WhatsApp': 'Channels · WhatsApp',
    'Каналы · Telegram Gateway': 'Channels · Telegram Gateway',
    'Каналы · Telegram-бот': 'Channels · Telegram bot',
    'Каналы · Web Push': 'Channels · Web Push',
    'Каналы · Push': 'Channels · Push',
    'Каналы · канал': 'Channels · channel',
    'Уведомления · погружение': 'Notifications · deep dive',
    'Шаблоны · Code2Email': 'Templates · Code2Email',
    'Шаблоны · редактор': 'Templates · editor',
    'Детектив логов': 'Log detective',
    'Журнал действий': 'Activity log',
    'Тариф и оплата · счёт': 'Plan and billing · invoice',
    // MfaStep.tsx
    'Время на ввод кода вышло. Войдите заново.': 'The time to enter the code has run out. Sign in again.',
    'Слишком много попыток. Подождите минуту.': 'Too many attempts. Wait a minute.',
    'Сеть недоступна.': 'Network unavailable.',
    'Двухфакторный вход': 'Two-factor sign-in',
    'Код восстановления': 'Recovery code',
    'Код из приложения': 'Code from the app',
    'Формат xxxxx-xxxxx, каждый код работает один раз': 'Format xxxxx-xxxxx, each code works once',
    'Шесть цифр из Google Authenticator, 1Password и т.п.': 'Six digits from Google Authenticator, 1Password, etc.',
    'Проверяем…': 'Checking…',
    'Подтвердить': 'Confirm',
    'Ввести код из приложения': 'Enter the code from the app',
    'Нет доступа к телефону? Код восстановления': 'No access to your phone? Recovery code',
    // ui.tsx
    'Скопировано': 'Copied',
    'Копировать': 'Copy',
    'Закрыть': 'Close',
    'Ваш заказ оплачен': 'Your order is paid',
    '<p>Спасибо за покупку!</p>': '<p>Thank you for your purchase!</p>',
    'повтор не создаст дубль': 'a retry will not create a duplicate',
    'шаг': 'step',
    'Ответ сервера:': 'Server reply:',
    'Объём писем по дням': 'Email volume by day',
    'Писем: {n}': 'Emails: {n}',
    'Проблемы: {n}': 'Problems: {n}',
    'Штиль': 'Calm',
    'Волнение': 'Choppy',
    'Шторм': 'Storm',
  },
  uk: {
    'Отмена действия': 'Скасувати дію',
    'Режим просмотра': 'Режим перегляду',
    'Длительность': 'Тривалість',
    // format.ts: email statuses
    'В очереди': 'У черзі',
    'Передано': 'Передано',
    'Доставлено': 'Доставлено',
    'Отскок': 'Відскок',
    'Жалоба': 'Скарга',
    'Ошибка': 'Помилка',
    'Неизвестно': 'Невідомо',
    'Подавлено': 'Придушено',
    'Отменено MailOcean': 'Скасовано MailOcean',
    'Принято API, ждёт передачи провайдеру': 'Прийнято API, очікує передачі провайдеру',
    'Провайдер принял письмо': 'Провайдер прийняв лист',
    'Почтовый сервер получателя подтвердил приём': 'Поштовий сервер отримувача підтвердив прийом',
    'Постоянный отказ сервера получателя': 'Постійна відмова сервера отримувача',
    'Получатель отметил письмо как спам — добавлен в подавления': 'Отримувач позначив лист як спам — додано до списку придушення',
    'Провайдер окончательно отклонил письмо': 'Провайдер остаточно відхилив лист',
    'Результат передачи неизвестен; повторно не отправляем, чтобы не создать дубль': 'Результат передачі невідомий; повторно не надсилаємо, щоб не створити дубль',
    'Адрес в списке подавлений — письмо не отправлялось': 'Адреса у списку придушення — лист не надсилався',
    'Отменено сотрудником MailOcean до передачи провайдеру — письмо не отправлялось': 'Скасовано співробітником MailOcean до передачі провайдеру — лист не надсилався',
    // format.ts: timeline events
    'Принято API': 'Прийнято API',
    'Поставлено в очередь': 'Поставлено в чергу',
    'Передано провайдеру': 'Передано провайдеру',
    'Провайдер принял': 'Провайдер прийняв',
    'Повтор запланирован': 'Повтор заплановано',
    'Результат неизвестен': 'Результат невідомий',
    'Отклонено': 'Відхилено',
    'Доставлено получателю': 'Доставлено отримувачу',
    'Мягкий отскок': "М'який відскок",
    'Отложено сервером получателя': 'Відкладено сервером отримувача',
    'Жалоба на спам': 'Скарга на спам',
    'Исход сверен поддержкой MailOcean': 'Результат звірено службою підтримки MailOcean',
    // format.ts: bounce categories
    'Адреса не существует или ящик отключён': 'Адреси не існує або скриньку вимкнено',
    'Ящик переполнен': 'Скринька переповнена',
    'Сервер получателя ограничил отправителя по репутации': 'Сервер отримувача обмежив відправника через репутацію',
    'Не прошла проверка SPF/DKIM/DMARC домена отправителя': 'Не пройшла перевірка SPF/DKIM/DMARC домену відправника',
    'Проблема инфраструктуры отправки (PTR/TLS) — мы разбираемся': 'Проблема інфраструктури надсилання (PTR/TLS) — ми розбираємося',
    'Отказ из-за содержимого или ссылок': 'Відмова через вміст або посилання',
    'Письмо нарушает формат (RFC 5322)': 'Лист порушує формат (RFC 5322)',
    'Организация получателя не принимает такие письма (нужен allowlist)': 'Організація отримувача не приймає такі листи (потрібен allowlist)',
    'Отказ по политике сервера получателя': 'Відмова за політикою сервера отримувача',
    'Сервер получателя ограничил скорость': 'Сервер отримувача обмежив швидкість',
    'Временная ошибка': 'Тимчасова помилка',
    'Получатель пожаловался на спам': 'Отримувач поскаржився на спам',
    'Причина не распознана — мы разбираем такие ответы': 'Причину не розпізнано — ми розбираємо такі відповіді',
    // format.ts: explanations under a timeline event
    'Сервер получателя попросил повторить позже — повтор идёт': 'Сервер отримувача попросив повторити пізніше — повтор триває',
    'Не доставлено: истёк срок повторов': 'Не доставлено: минув строк повторів',
    'Адрес добавлен в подавления': 'Адресу додано до списку придушення',
    'Адрес не подавлен: причина на стороне отправителя, а не получателя': 'Адресу не придушено: причина на боці відправника, а не отримувача',
    'Адрес не подавлен': 'Адресу не придушено',
    // Layout.tsx
    'океан писем': 'океан листів',
    'Продолжить погружение': 'Продовжити занурення',
    'Отправка': 'Надсилання',
    'Аудитория': 'Аудиторія',
    'Маркетинг': 'Маркетинг',
    'Аккаунт': 'Обліковий запис',
    'Обзор': 'Огляд',
    'Письма': 'Листи',
    'Шаблоны': 'Шаблони',
    'Каналы': 'Канали',
    'Уведомления': 'Сповіщення',
    'Домены': 'Домени',
    'API-ключи': 'API-ключі',
    'Вебхуки': 'Вебхуки',
    'Детектив': 'Детектив',
    'Контакты': 'Контакти',
    'События': 'Події',
    'Сегменты': 'Сегменти',
    'Подавления': 'Придушення',
    'Пилот': 'Пілот',
    'Сценарии': 'Сценарії',
    'Команда': 'Команда',
    'Безопасность': 'Безпека',
    'Тариф и оплата': 'Тариф і оплата',
    'Журнал': 'Журнал',
    'Настройки': 'Налаштування',
    'Правила (без AI)': 'Правила (без AI)',
    'правила': 'правила',
    'Сменить тему': 'Змінити тему',
    'Выйти': 'Вийти',
    'Сменить рабочее пространство': 'Змінити простір',
    'Новое пространство': 'Новий простір',
    'Название нового рабочего пространства': 'Назва нового простору',
    'Язык интерфейса': 'Мова інтерфейсу',
    'Отправка заблокирована MailOcean: API не принимает новые письма.': 'Надсилання заблоковано MailOcean: API не приймає нові листи.',
    'Отправка приостановлена MailOcean: письма принимаются и ждут в очереди.': 'Надсилання призупинено MailOcean: листи приймаються і чекають у черзі.',
    'Напишите в поддержку, чтобы узнать подробности': 'Напишіть у підтримку, щоб дізнатися подробиці',
    'Письма, уже переданные провайдеру, остановить нельзя.': 'Листи, що вже передані провайдеру, зупинити не можна.',
    'Поток «{streams}» приостановлен MailOcean.': 'Потік «{streams}» призупинено MailOcean.',
    'маркетинг': 'маркетинг',
    'транзакционные': 'транзакційні',
    'Письма этого потока ждут в очереди; остальные отправляются как обычно.': 'Листи цього потоку чекають у черзі; решта надсилаються як звичайно.',
    'Режим просмотра поддержки — только чтение.': 'Режим перегляду підтримки — лише читання.',
    '{name} из MailOcean смотрит пространство так, как его видит владелец; изменить ничего нельзя. Доступ записан в журнал действий.': '{name} з MailOcean переглядає простір так, як його бачить власник; нічого не можна змінити. Доступ записано в журнал дій.',
    'Письма · детали': 'Листи · деталі',
    'Домены · DNS': 'Домени · DNS',
    'Контакты · карточка': 'Контакти · картка',
    'Сегменты · редактор': 'Сегменти · редактор',
    'Пилот · словарь': 'Пілот · словник',
    'Пилот · поручение': 'Пілот · доручення',
    'Сценарии · течение': 'Сценарії · перебіг',
    'Каналы · политика': 'Канали · політика',
    'Каналы · политики': 'Канали · політики',
    'Каналы · шаблон': 'Канали · шаблон',
    'Каналы · шаблоны': 'Канали · шаблони',
    'Каналы · расходы': 'Канали · витрати',
    'Каналы · настройки': 'Канали · налаштування',
    'Каналы · SMS': 'Канали · SMS',
    'Каналы · WhatsApp': 'Канали · WhatsApp',
    'Каналы · Telegram Gateway': 'Канали · Telegram Gateway',
    'Каналы · Telegram-бот': 'Канали · Telegram-бот',
    'Каналы · Web Push': 'Канали · Web Push',
    'Каналы · Push': 'Канали · Push',
    'Каналы · канал': 'Канали · канал',
    'Уведомления · погружение': 'Сповіщення · занурення',
    'Шаблоны · Code2Email': 'Шаблони · Code2Email',
    'Шаблоны · редактор': 'Шаблони · редактор',
    'Детектив логов': 'Детектив логів',
    'Журнал действий': 'Журнал дій',
    'Тариф и оплата · счёт': 'Тариф і оплата · рахунок',
    // MfaStep.tsx
    'Время на ввод кода вышло. Войдите заново.': 'Час для введення коду минув. Увійдіть знову.',
    'Слишком много попыток. Подождите минуту.': 'Забагато спроб. Зачекайте хвилину.',
    'Сеть недоступна.': 'Мережа недоступна.',
    'Двухфакторный вход': 'Двофакторний вхід',
    'Код восстановления': 'Код відновлення',
    'Код из приложения': 'Код із застосунку',
    'Формат xxxxx-xxxxx, каждый код работает один раз': 'Формат xxxxx-xxxxx, кожен код працює один раз',
    'Шесть цифр из Google Authenticator, 1Password и т.п.': 'Шість цифр із Google Authenticator, 1Password тощо.',
    'Проверяем…': 'Перевіряємо…',
    'Подтвердить': 'Підтвердити',
    'Ввести код из приложения': 'Ввести код із застосунку',
    'Нет доступа к телефону? Код восстановления': 'Немає доступу до телефону? Код відновлення',
    // ui.tsx
    'Скопировано': 'Скопійовано',
    'Копировать': 'Копіювати',
    'Закрыть': 'Закрити',
    'Ваш заказ оплачен': 'Ваше замовлення оплачено',
    '<p>Спасибо за покупку!</p>': '<p>Дякуємо за покупку!</p>',
    'повтор не создаст дубль': 'повтор не створить дубль',
    'шаг': 'крок',
    'Ответ сервера:': 'Відповідь сервера:',
    'Объём писем по дням': 'Обсяг листів за днями',
    'Писем: {n}': 'Листів: {n}',
    'Проблемы: {n}': 'Проблеми: {n}',
    'Штиль': 'Штиль',
    'Волнение': 'Хвиля',
    'Шторм': 'Шторм',
  },
};
